/**
 * Shipping Rates API Client
 * Handles all API requests related to shipping rates management
 */

import { client } from "@/lib/hono";

/**
 * Get all shipping rates
 */
export async function getShippingRates() {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api["shipping-rates"].$get();
  if (!response.ok) {
    throw new Error("Failed to fetch shipping rates");
  }
  return await response.json();
}

/**
 * Get a single shipping rate by ID
 */
export async function getShippingRate(id: string) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api["shipping-rates"][":id"].$get({ param: { id } });
  if (!response.ok) {
    throw new Error("Failed to fetch shipping rate");
  }
  return await response.json();
}

/**
 * Create a new shipping rate
 */
export async function createShippingRate(data: Record<string, unknown> | { name: string; price: string; description?: string }) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api["shipping-rates"].$post({ json: data });
  if (!response.ok) {
    throw new Error("Failed to create shipping rate");
  }
  return await response.json();
}

/**
 * Update an existing shipping rate
 */
export async function updateShippingRate(id: string, data: Record<string, unknown> | { name?: string; price?: string; description?: string }) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api["shipping-rates"][":id"].$put({
    param: { id },
    json: data,
  });
  if (!response.ok) {
    throw new Error("Failed to update shipping rate");
  }
  return await response.json();
}

/**
 * Delete a shipping rate
 */
export async function deleteShippingRate(id: string) {
  // @ts-expect-error - Type will be available after server type regeneration
  const response = await client.api["shipping-rates"][":id"].$delete({ param: { id } });
  if (!response.ok) {
    throw new Error("Failed to delete shipping rate");
  }
}
